import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Button, Flex, Form, Tag } from "antd";
import Modal from "antd/es/modal/Modal";
import { observer } from "mobx-react-lite";
import React from "react";
import { SaveConfig } from "../types/Config";
import { AddFieldConfig } from "./AddFieldConfig";
import { FieldConfigListItem } from "./FieldConfigListItem";

type Props = {
  value: SaveConfig;
  setValue: (value: SaveConfig) => void;
};

export const TicketFormConfigParseField = observer((props: Props) => {
  const t = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [from] = Form.useForm<SaveConfig>();
  const value: SaveConfig = React.useMemo(
    () => props.value ?? { config: [] },
    [props.value]
  );

  function onSubmit(values: SaveConfig) {
    props.setValue(values);
    setOpen(false);
  }

  if (!props.setValue) return <Tag>Config</Tag>;
  return (
    <>
      <Button icon={<Icon icon="fa:link" />} onClick={() => setOpen(true)}>
        {t("maintenance:ticket.create.config.button")}
      </Button>
      <Modal
        width="80%"
        open={open}
        onCancel={() => setOpen(false)}
        // onClose={() => setOpen(false)}
        title={t("maintenance:ticket.create.config.form.title")}
        footer={null}
      >
        <Form
          layout="vertical"
          onFinish={onSubmit}
          form={from}
          initialValues={value}
        >
          <Form.List name="config">
            {(fields, { add, remove, move }) => (
              <Flex vertical gap="small">
                {fields.map((field, index) => (
                  <FieldConfigListItem
                    key={field.key}
                    field={field}
                    length={fields.length}
                    index={index}
                    namePath={["config", index]}
                    onRemove={() => remove(index)}
                    moveUp={() => {
                      if (index > 0) {
                        move(index, index - 1);
                      }
                    }}
                    moveDown={() => {
                      if (index < fields.length - 1) {
                        move(index, index + 1);
                      }
                    }}
                  />
                ))}
                <AddFieldConfig
                  name={["config"]}
                  onAdd={(params) => {
                    add(params);
                  }}
                />
              </Flex>
            )}
          </Form.List>
          <Button
            type="primary"
            htmlType="submit"
            style={{ marginTop: "1rem" }}
          >
            {t("maintenance:ticket.create.config.form.submit")}
          </Button>
        </Form>
      </Modal>
    </>
  );
});
